var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArtigo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.4,7.2c0.3,0,0.6,0.3,0.6,0.6V19c0,1.2-0.9,2.1-2.1,2.1H7.8c-1.2,0-2.1-0.9-2.1-2.1V5.4 c0-1.2,0.9-2.1,2.1-2.1h6.9c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6H7.8c-0.5,0-0.9,0.4-0.9,0.9V19c0,0.5,0.4,0.9,0.9,0.9h9.2 c0.5,0,0.9-0.4,0.9-0.9V7.8C17.9,7.5,18.1,7.2,18.4,7.2 M8,7.4c0,0.3,0.2,0.5,0.5,0.5H16c0.3,0,0.5-0.2,0.5-0.5 c0-0.3-0.2-0.5-0.5-0.5H8.5C8.2,6.8,8,7.1,8,7.4 M16,10.1H8.5c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5H16c0.3,0,0.5-0.2,0.5-0.5 S16.3,10.1,16,10.1 M16,13.3H8.5c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5H16c0.3,0,0.5-0.2,0.5-0.5 C16.6,13.5,16.3,13.3,16,13.3 M16,16.5H8.5c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5H16c0.3,0,0.5-0.2,0.5-0.5 C16.6,16.8,16.3,16.5,16,16.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtigo);
export default __webpack_public_path__ + "static/media/artigo.574e1c9d6ca5d5c9a383faead60a8bba.svg";
export { ForwardRef as ReactComponent };